import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import update from "immutability-helper";
import { useTopicPage_Views_LabelQuery, ItemType } from "sprout-graphql";
import { Glitch, NotFound } from "@sprout/views";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import Head from "@sprout/client-layout/dist/Head";
import TopicPagePage from "../TopicPage_Page";
import TopicPageViewsLabelMain from "./TopicPageViewsLabelMain";
import TopicPageViewsLabelMenu from "./TopicPageViewsLabelMenu";
import TopicPageViewsLabelAppBarMobile from "./TopicPageViewsLabelAppBarMobile";
const TopicPageViewsLabel = ()=>{
    var ref;
    const { topicId , labelId  } = useParams();
    const { loading , error , data , updateQuery  } = useTopicPage_Views_LabelQuery({
        variables: {
            topicId: Number(topicId),
            labelId: Number(labelId),
            phrase: `label:${String(labelId)} -is:archived kind:POST kind:CHECKLIST_ITEM`
        },
        fetchPolicy: "cache-and-network"
    });
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const label = data === null || data === void 0 ? void 0 : data.label;
    const posts = data === null || data === void 0 ? void 0 : data.posts;
    const isInitialLoad = loading && !topic && !label && !posts;
    useLoadingProgress(isInitialLoad);
    const updateList = useCallback((itemIds)=>{
        updateQuery((prevResult)=>{
            return update(prevResult, {
                posts: {
                    nodes: {
                        $apply: (nodes)=>nodes.filter(({ id  })=>{
                                if (typeof itemIds === "number") return id !== itemIds;
                                return !itemIds.includes(id);
                            })
                    }
                }
            });
        });
    }, [
        updateQuery
    ]);
    if (isInitialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!posts || !label || !topic || topic.type !== ItemType.Topic || !topic.isRootTopic || ((ref = topic.rootTopicOrSelf) === null || ref === void 0 ? void 0 : ref.special) === "PROFILE") return /*#__PURE__*/ _jsx(NotFound, {});
    const { title , linkImages , description  } = topic;
    const metaTagImage = linkImages && linkImages[0];
    const { text  } = label;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: title ? `${title}${text ? ` (${text})` : ""} | Sprout` : "Sprout",
                description: description,
                image: metaTagImage
            }),
            /*#__PURE__*/ _jsx(TopicPagePage, {
                topic: topic,
                appBar: /*#__PURE__*/ _jsx(TopicPageViewsLabelMenu, {
                    variant: "desktop",
                    label: label
                }),
                main: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TopicPageViewsLabelAppBarMobile, {
                            label: label
                        }),
                        /*#__PURE__*/ _jsx(TopicPageViewsLabelMain, {
                            topic: topic,
                            label: label,
                            posts: posts.nodes,
                            updateList: updateList
                        })
                    ]
                })
            })
        ]
    });
};
export default TopicPageViewsLabel;
